import { z } from 'zod/v4'
import { CountryCode } from '@/constants/country-code'
import type { LanguageCodeType } from '@/constants/search/language-code'
import { genderSchema } from '@/types/schema/common/gender-schema'
import { kpiSchema } from '@/types/schema/kol/kpi-schema'
import { linkSchema } from '@/types/schema/kol/link-schema'
import potentialSchema from '@/types/schema/kol/potential'

export const publicKolInfoSchema = z.object({
  id: z.string(),
  name: z.string(),
  sub_names: z.string().array(),
  gender: genderSchema.nullable(),
  customized_tags_names: z.string().array(),
  description: z.string(),
  custom_tag: z.string().nullable(),
  verified: z.boolean(),
  visibility: z.boolean(),
  links: linkSchema.array(),
  follower: z.number().catch(0).describe('建立中的網紅有可能是 null'),
  max_interactive_rate_3m: z.number(),
  max_fans_up_rate_3m: z.number(),
  max_avg_pvRate_3m: z.number(),
  crawled_description: z.string().nullable(),
  potential: potentialSchema.nullable(),
  country_code: z.enum(CountryCode).nullable(),
  is_collection_kol: z.boolean(),
  languages: z
    .object({
      name: z.custom<LanguageCodeType>(),
      weight: z.string(),
    })
    .array(),
  kpi: kpiSchema.array(),
})

export type PublicKolInfo = z.infer<typeof publicKolInfoSchema>
